import { Component } from 'react'
import { connect } from 'react-redux'
import SmoothCollapse from 'react-smooth-collapse'
import TaskMenu from './task-menu'

import { saveTaskStatuses, updateTask } from 'state/actions'
import { processStatuses } from 'state/selectors'

import Icon from 'components/icon/icon'
import copy from 'fast-copy'

class TaskStatus extends Component {
	state = {}

	statusIndexIfExists = (item, selectedItems) => {
		return (selectedItems && selectedItems.includes(item.id))
	}

	clickStatus = status => {
		const {
			task,
			updateTask,
			column
		} = this.props

		let activity
		let historyStatusId = null

		let columnData = task.column_data ? copy(task.column_data[column.id]) : null

		if(columnData == status.id){
			columnData = null

			historyStatusId = status.id
			activity = 'REMOVE'
		}else{
			columnData = status.id
			
			historyStatusId = status.id
			activity = 'ADD'
		}

		updateTask({
			...task,
			column_data: {
				...task.column_data,
				[column.id]: columnData
			}
		})
	}

	clickMenu = _ => {
		const {
			isDisabled,
			menuState,
			task,
			openMenu,
			column
		} = this.props

		if (!isDisabled) {
			if (menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id) {
				openMenu(null)
			} else {
				if (task) {
					openMenu(column.id, task.id)
				}
			}
		}
	}

	getSelectedItem = _ => {
		const {
			task,
			column
		} = this.props

		if(task && column && task.column_data && task.column_data[column.id]){
			return task.column_data[column.id]
		}else{
			return null
		}
	}

	render() {
		const {
			allStatuses,
			column,
			currentProjectId,
			isDisabled,
			isSingle,
			menuItems,
			menuState,
			openMenu,
			saveTaskStatuses,
			task,
		} = this.props

		let isOpened = false
		let statusObject = null

		let className = 'task-status '

		let statusIconClass = 'status-icon'

		const selectedStatusId = this.getSelectedItem()

		if (!task || !selectedStatusId) {
			className += ' hidden'
		} else {
			statusObject = allStatuses[selectedStatusId]
			className += ' has-status';
			statusIconClass += ' colour-id-' + statusObject.colour_id
		}

		if (menuState.currentOpenColumnId == column.id && menuState.currentFocusedTask == task.id) {
			isOpened = true
			className += ' active'
		}

		let itemName = ''

		if (statusObject && menuItems && menuItems.length) {
			let selectedMenuItem = menuItems.find(item => {
				return item.id === statusObject.id
			})

			if (selectedMenuItem.custom_name) {
				itemName = selectedMenuItem.custom_name
			} else {
				itemName = selectedMenuItem.name
			}
		}

		if(isDisabled){
			className += ' disabled'
		}

		return (
			<a 
				className={className} 
				onClick={this.clickMenu}
				href="javascript:void(0)"
			>
				{ statusObject ?
					statusObject.colour_id == 3 ?
						<Icon name="check" />
						:
						<em className={statusIconClass}></em>
					: null
				}
				<span className="status-label">
					{ itemName ?
						itemName
						:
						'No status'
					}
				</span>
				{ task ?
					<div className={'smooth-collapse-container'}>
						<SmoothCollapse 
							heightTransition="0.15s ease" 
							expanded={isOpened}
							className="task-menu-collapse"
						>
							<TaskMenu 
								isOpened={isOpened} 
								dismissCallback={openMenu} 
								projectId={currentProjectId} 
								saveTaskStatuses={saveTaskStatuses} 
								column={column}
								type="status" 
								menuItems={menuItems} 
								selectedMenuItems={selectedStatusId ? [selectedStatusId] : []} 
								selectCallback={this.clickStatus} 
								isSelectedCheck={this.statusIndexIfExists} 
								taskId={task.id} 
								isSingle={isSingle}
							/>
						</SmoothCollapse>
					</div>
				: null }
			</a>
		);
	}

}

const mapStateToProps = (state, props) => {
	return {
		allStatuses: state.account.entities.statuses,
		allProjects: state.account.entities.projects,
		currentProjectId: state.account.currentProjectId,
		menuItems: processStatuses(state, props)
	}
}

export default connect(mapStateToProps, { updateTask, saveTaskStatuses })(TaskStatus)
